module.exports = __webpack_public_path__ + "img/horizontal_4_5_5.de0874fe.png";